import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const faqs = [
  {
    question: "WHAT IS UNIXORN?",
    answer: "UNIXORN is a design house focused on form, identity, and rarity. The brand produces limited pieces designed to endure beyond season."
  },
  {
    question: "WHAT DOES \"UNIQUE × ORIGINAL\" MEAN?",
    answer: "It represents the crossing between individuality and creation — the space where something truly new is formed."
  },
  {
    question: "WHAT IS THE SIGIL USED FOR?",
    answer: "The Sigil marks select pieces. It is reserved for designs considered relic-grade — items meant to outlive trend."
  },
  {
    question: "ARE YOUR PIECES LIMITED?",
    answer: "Yes. Some releases are produced once and never repeated. Others return only in evolved form."
  },
  {
    question: "WHEN WILL FOOTWEAR BE AVAILABLE?",
    answer: "Footwear is currently in development and will be released when the design is fully realized. No dates are rushed."
  },
  {
    question: "WHERE ARE UNIXORN PIECES MADE?",
    answer: "Production varies by piece and material. Quality and longevity guide all manufacturing decisions."
  },
  {
    question: "HOW SHOULD I CARE FOR MY PIECE?",
    answer: "Care instructions are included where relevant. UNIXORN pieces are designed to age with character, not degrade."
  },
  {
    question: "HOW DO I KNOW WHEN NEW PIECES DROP?",
    answer: "Announcements are made quietly through the site and select channels. Those paying attention arrive first."
  },
  {
    question: "DOES EVERY ORDER INCLUDE A PHYSICAL COMIC BOOK?",
    answer: "Every UNIXORN order includes digital access to The UNIXORN Chronicles. Physical editions are reserved for select limited releases."
  },
  {
    question: "HOW DO I CONTACT UNIXORN?",
    answer: "For inquiries, collaborations, or support — reach us at info@unixornworldwide.com. We respond with intention, not automation."
  }
];

export default function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F4EFE6] relative">
      <Navigation />

      <main className="pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-8">
          <p className="text-[11px] tracking-[0.4em] uppercase text-stone-500 mb-5">
            UNIXORN — Questions
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-stone-900 tracking-tight mb-16 md:mb-24">
            FAQ
          </h1>

          <div className="space-y-16 md:space-y-20">
            {faqs.map((faq) => (
              <div key={faq.question}>
                <h2 className="text-lg md:text-xl font-display font-bold text-stone-900 tracking-wide mb-6">
                  {faq.question}
                </h2>
                <p className="text-base md:text-lg text-stone-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
